// The two map marks, drawn here because lucide has neither. Same pair the
// campus hero uses, so Directions looks like Directions everywhere.
export function GoogleMapsMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <defs>
        <clipPath id="ed-gpin">
          <path d="M12 1.5a7.5 7.5 0 0 0-7.5 7.5c0 5.3 6.4 12.2 7 12.8a.7.7 0 0 0 1 0c.6-.6 7-7.5 7-12.8A7.5 7.5 0 0 0 12 1.5z" />
        </clipPath>
      </defs>
      <g clipPath="url(#ed-gpin)">
        <rect width="24" height="24" fill="#34A853" />
        <polygon points="0,0 24,0 0,24" fill="#4285F4" />
        <polygon points="8,0 24,0 24,16" fill="#EA4335" />
        <polygon points="0,10 14,24 0,24" fill="#FBBC04" />
      </g>
      <circle cx="12" cy="9" r="2.6" fill="#fff" />
    </svg>
  );
}

export function AppleMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        fill="currentColor"
        d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
      />
    </svg>
  );
}
